const state = {
    device_name: "",
    shipment_process:""
}
const getters = {
    get_deviceName: state => {
        return state.device_name
    },
    get_shipmentProcess: state => {
        return state.shipment_process
    }
}
const actions = {
    set_deviceName(context, String) {
        context.commit('SET_DEVICENAME', String);
    },
    set_shipmentProcess(context, String) {
        context.commit('SET_SHIPMENTPROCESS', String);
    },
    clear_shipmentProcess(context) {
        context.commit('CLEAR_SHIPMENTPROCESS');
    }
}
const mutations = {
    SET_DEVICENAME(state, String) {
        state.device_name = String;
    },
    SET_SHIPMENTPROCESS(state, String) {
        state.shipment_process = String;
    },
    CLEAR_SHIPMENTPROCESS(state) {
        state.shipment_process = "";
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/selectDevice.js